import React from 'react';
import { InformationBlockProps } from '../../types';
import styles from './InformationBlock.module.css';
import { getViewConfig } from '../../lib/getViewConfig';
import { renderIndicators } from '../../lib/renderIndicators';
import { Typography } from '@mui/material';

export const InformationBlock: React.FC<InformationBlockProps> = ({
  account,
  todaySales,
}) => {
  const fullName = `${account.name.last} ${account.name.first}`;

  const isTerritorialManager = account.jobTitle === 'Территориальный менеджер';
  const isPilotUser = todaySales.pilotUser;

  const config = getViewConfig(isTerritorialManager, isPilotUser);

  return (
    <div className={styles.informationBlockWrapper}>
      <div className={styles.account}>
        <div className={styles.userInfo}>
          <Typography
            variant="h5"
            component="h1"
            sx={{ p: '5px 0', fontWeight: 600 }}
          >
            {fullName}
          </Typography>
        </div>

        <div className={styles.accountIndicatorsWrapper}>
          <div className={styles.accountIndicatorsMain}>
            {renderIndicators(config, todaySales)}
          </div>
        </div>
      </div>
    </div>
  );
};
